import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayTextFilter'
})
export class ArrayTextFilterPipe implements PipeTransform {

    transform(items: any[], value: string, field = 'shortLabel'): any[] {
        if (!items) {
            return [];
        }

        if (!field || value == null) {
            return items;
        }

        return [...items.filter(item => item.text ? item.text[field].toLowerCase().includes(value.trim().toLowerCase()) : true)];
    }

}
